import { Card, Row, Tabs } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import ImportExportDevLogsList from './import-export-dev-logs/import-export-dev-logs-list';
import ScopeLogsList from './scope-logs/scope-logs-list';

const DevLogsPage: FC = () => {
  const { t } = useTranslation();
  setHeader(t('DevLogs'));
  setRoutes([
    { path: '', breadcrumbName: t('Home') },
    { path: 'dev-logs', breadcrumbName: t('DevLogs') },
  ]);

  return (
    <Row align="top" justify="space-between">
      <Card className="card-table" style={{ width: '100%' }}>
        <Row align="top" justify="space-between">
          <Tabs defaultActiveKey="1" style={{ width: '100%', height: '100%', marginLeft: '20px', marginRight: '20px' }}>
            <Tabs.TabPane tab={t('ImportExport')} key="1">
              <ImportExportDevLogsList />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Scope')} key="2">
              <ScopeLogsList />
            </Tabs.TabPane>
          </Tabs>
        </Row>
      </Card>
    </Row>
  );
};

export default DevLogsPage;
